import {
  ServiceCard,
  ServiceCardCreateData,
  ServiceCardUpdateData,
  ServiceCardFilters,
  ServiceCardEvaluateData,
  ServiceCardStats,
  ServiceCardAuditEntry,
  PaginatedServiceCards,
  ApiResponse,
} from 'shared/types';
import api from './apiClient';

class ServiceCardApi {
  static async create(data: ServiceCardCreateData): Promise<ServiceCard> {
    const result = await api.post('/service-cards', data);
    return result.data ?? result;
  }

  static async getAll(filters?: ServiceCardFilters): Promise<PaginatedServiceCards> {
    const params: Record<string, any> = {};
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          params[key] = value;
        }
      });
    }

    const apiResponse: ApiResponse<ServiceCard[]> = await api.get('/service-cards', params);
    return {
      data: apiResponse.data || [],
      total: apiResponse.pagination?.total || 0,
      page: apiResponse.pagination?.page || 1,
      limit: apiResponse.pagination?.limit || 20,
      totalPages: apiResponse.pagination?.pages || 1,
    };
  }

  static async getById(id: string): Promise<ServiceCard> {
    const result = await api.get(`/service-cards/${id}`);
    return result.data ?? result;
  }

  static async update(id: string, data: ServiceCardUpdateData): Promise<ServiceCard> {
    const result = await api.put(`/service-cards/${id}`, data);
    return result.data ?? result;
  }

  static async evaluate(id: string, data: ServiceCardEvaluateData): Promise<ServiceCard> {
    const result = await api.post(`/service-cards/${id}/evaluate`, data);
    return result.data ?? result;
  }

  static async close(id: string): Promise<ServiceCard> {
    const result = await api.post(`/service-cards/${id}/close`);
    return result.data ?? result;
  }

  static async getStats(companyId?: string): Promise<ServiceCardStats> {
    const params = companyId ? { company: companyId } : undefined;
    const result = await api.get('/service-cards/stats', params);
    return result.data ?? result;
  }

  static async getAuditLog(id: string): Promise<ServiceCardAuditEntry[]> {
    const result = await api.get(`/service-cards/${id}/audit-log`);
    return result.data ?? result;
  }
}

export default ServiceCardApi;
